module.exports = __webpack_public_path__ + "49c7ac65cea6aaccc526d07cd5adb0e9.MP3";